import {
  BusBrandBase,
  BusBrandCreatePayload,
  BusBrandFormValues,
  BusBrandUpdatePayload,
} from './type'

export function mapAPIDataToFormValues(data: BusBrandBase): BusBrandFormValues {
  return {
    id: data.bus_type_id,
    busBrand: data.bus_type,
    busBrandStatus: data.bus_type_status,
  }
}

export function mapFormDataToCreatePayload(data: BusBrandFormValues): BusBrandCreatePayload {
  return {
    bus_type: data.busBrand,
    bus_type_status: data.busBrandStatus,
  }
}

export function mapFormDataToUpdatePayload(data: BusBrandFormValues): BusBrandUpdatePayload {
  return {
    id: data.id!,
    bus_type: data.busBrand,
    bus_type_status: data.busBrandStatus,
  }
}
